module.exports = __webpack_public_path__ + "static/media/ai_worth_4.e3ddadbc.png";